import Vue from 'vue';
import {mapState,mapActions} from 'vuex';
import $ from 'jquery' ;
import { Toast } from 'vant';
import http from '../../utils/config';
import Axios from 'axios';
let Base64 = require('js-base64').Base64;
import { PullRefresh } from 'vant';

Vue.use(PullRefresh);
export default {
  name: 'questionDetail',
  data() {
    return {
title:'',
time:'',
rTime:'',
response:'',
content:'',
chatAdviceMemberReply:''
    };

  },
  updated(){


  },
  created() {
    this.getListDetail()
  },
  methods: {
    ...mapActions('bot', ['add','postfile','findList','listDetail']),
    back() {
      this.$router.go(-1);
    },
    getListDetail(){


this.listDetail(this.$route.query.id).then(res=>{
this.title=res.data.chatAdviceTitle;
this.time=res.data.createTime;
this.rTime=res.data.chatAdviceResponseTime;
this.response=res.data.chatAdviceResponse;
this.content=res.data.chatAdviceContent;
this.chatAdviceMemberReply=res.data.chatAdviceMemberReply
})
}
  },

};
